import { render, staticRenderFns } from "./IssueCredentials.vue?vue&type=template&id=64f8cffb"
import script from "./IssueCredentials.vue?vue&type=script&lang=js"
export * from "./IssueCredentials.vue?vue&type=script&lang=js"
import style0 from "./IssueCredentials.vue?vue&type=style&index=0&id=64f8cffb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports